module.exports = __webpack_public_path__ + "static/media/icons_Bilan d‚couverte - membres sup‚rieurs.130d8574.svg";